import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import 'assets/styles/common.scss';
import AbsolutLogo from 'assets/images/absolute-logo.svg';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import ReusableButton from 'components/commom/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { loginUsers } from 'store/login/LoginAction';
import CheckValidation from 'utils/validate';
import LabelWithInput from 'components/commom/LabelWithInput';
import { ClearTokenRedirectLogin, enCodeBase64 } from 'utils/general';
import { dashboard, login, otp } from 'routes/AppUrls';
import LocalStorageManager from 'managers/LocalStorageManger';
import CommonToast from 'components/commom/CommonToast';
import Loader from 'components/commom/Loader';
import { validateTokenCallAPI } from 'store/validateToken/action';
import { setPasswordCallAPI } from 'store/setPassword/action';

const SetupPassword = () => {
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const { locale } = useContext(LocaleContext);
  const [searchParams] = useSearchParams();
  const [isPassVisible, setIsPassVisible] = useState(false);
  const [isConfirmPassVisible, setIsConfirmPassVisible] = useState(false);
  const [formValue, setformValue] = useState({
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(true);

  const validateTokenLoader = useSelector(
    (state) => state?.validateTokenReducer?.loading
  );
  const validateTokenData = useSelector((state) => state?.validateTokenReducer);
  const setPasswordLoader = useSelector(
    (state) => state?.setPasswordReducer?.loading
  );

  useEffect(() => {
    setLoading(true);
    dispatch(
      validateTokenCallAPI(`?token=${searchParams.get('token')}`, {
        run: true,
        handleFunction: () => {
          setLoading(false);
        },
        authorize: true,
        handleAuthorizeFunction: () => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: () => {
          setLoading(false);
        },
      })
    );
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setformValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    const error = CheckValidation(formValue);
    setIsError(error);
    if (error.submit) {
      if (formValue?.password !== formValue?.confirmPassword) {
        showToast('Passwords do not match', 'error');
        return;
      }
      const body = {
        token: searchParams.get('token'),
        password: formValue?.password,
        confirm_password: formValue?.confirmPassword,
      };
      dispatch(
        setPasswordCallAPI(body, {
          run: true,
          handleFunction: (res) => {
            showToast(res?.message, 'success');
            navigate(login(locale));
          },
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            const dataMessages = res?.data && Object.values(res.data).flat();
            const errorMessage = dataMessages?.length
              ? dataMessages[0]
              : res?.message;
            showToast(errorMessage, 'error');
          },
        })
      );
    }
  };

  return (
    <>
      <Row className="m-0 p-0 landing-image">
        {validateTokenLoader || loading ? (
          <Loader width={'100vw'} />
        ) : (
          <Row className="m-0 p-0 flex justify-content-center">
            <Col
              xs={12}
              sm={10}
              md={10}
              lg={6}
              xl={6}
              xxl={4}
              className="bg-light-100 m-sm-auto m-lg-auto login-card p-0"
            >
              <div class="py-60 px-40">
                <div className="d-flex">
                  <Image src={AbsolutLogo} alt={'icon'} />
                </div>
                {!validateTokenData?.data?.data ? (
                  <div className="mt-[10%] fs-20 family_outfit_regular_400 lh-26 fc-6B788E">
                    <div>{validateTokenData?.error?.message}</div>
                    <div className="mt-[30px]">You may now close this tab.</div>
                  </div>
                ) : (
                  <>
                    <div className="main-heading pt-24 family_outfit_semiBold_600">
                      Set Password
                    </div>
                    <div className="pt-12 fs-20 family_outfit_regular_400 lh-26 fc-6B788E">
                      Please set up your password
                    </div>
                    <Row>
                      <Col sm={12} className="">
                        <div className="pt-40">
                          <LabelWithInput
                            label="Password"
                            placeholder="Enter your password"
                            name="password"
                            value={formValue?.password}
                            type={isPassVisible ? 'text' : 'password'}
                            onChange={handleInputChange}
                            InputProps={{
                              endAdornment: (
                                <>
                                  {isPassVisible ? (
                                    <VisibilityOutlinedIcon
                                      sx={{
                                        cursor: 'pointer',
                                        color: '#A4AAB2',
                                      }}
                                      onClick={() =>
                                        setIsPassVisible(!isPassVisible)
                                      }
                                    />
                                  ) : (
                                    <VisibilityOffOutlinedIcon
                                      sx={{
                                        cursor: 'pointer',
                                        color: '#A4AAB2',
                                      }}
                                      onClick={() =>
                                        setIsPassVisible(!isPassVisible)
                                      }
                                    />
                                  )}
                                </>
                              ),
                            }}
                            errorText={
                              isError &&
                              isError.password.error &&
                              isError.password.errorMessage
                            }
                          />
                        </div>
                      </Col>
                      <Col sm={12}>
                        <div className="pt-16">
                          <LabelWithInput
                            label="Confirm Password"
                            placeholder="Enter your password"
                            name="confirmPassword"
                            value={formValue?.confirmPassword}
                            type={isConfirmPassVisible ? 'text' : 'password'}
                            onChange={handleInputChange}
                            InputProps={{
                              endAdornment: (
                                <>
                                  {isConfirmPassVisible ? (
                                    <VisibilityOutlinedIcon
                                      sx={{
                                        cursor: 'pointer',
                                        color: '#A4AAB2',
                                      }}
                                      onClick={() =>
                                        setIsConfirmPassVisible(
                                          !isConfirmPassVisible
                                        )
                                      }
                                    />
                                  ) : (
                                    <VisibilityOffOutlinedIcon
                                      sx={{
                                        cursor: 'pointer',
                                        color: '#A4AAB2',
                                      }}
                                      onClick={() =>
                                        setIsConfirmPassVisible(
                                          !isConfirmPassVisible
                                        )
                                      }
                                    />
                                  )}
                                </>
                              ),
                            }}
                            errorText={
                              isError &&
                              isError.confirmPassword.error &&
                              isError.confirmPassword.errorMessage
                            }
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pt-28">
                      <ReusableButton
                        fullWidth={true}
                        variant="outlined"
                        color="#F5F5F5"
                        fontSize="16px"
                        fontWeight="500"
                        padding="12px 24px"
                        borderRadius="8px"
                        height="48px"
                        bgColor="#2C2C2C"
                        brColor=""
                        fontFamily="outfit_semiBold"
                        onClick={() => {
                          !setPasswordLoader && handleSubmit();
                        }}
                        loading={setPasswordLoader}
                      >
                        Setup Password
                      </ReusableButton>
                    </div>
                  </>
                )}
              </div>
            </Col>
          </Row>
        )}
      </Row>
    </>
  );
};
export default SetupPassword;
